import { FC } from 'react';
import CompanyList from './CompanyList';
import UseCompanyList from './UseCompanyList';

const CompanyListContainer: FC = () => {
  return <CompanyList {...UseCompanyList()} />;
};

export default CompanyListContainer;
